import apiClient from './apiClient';

/**
 * Obtine raportul AI pentru o procedura SEAP.
 * Timeout mare (5 min) - generarea dureaza: download fisa de date + analiza Claude AI
 */
export const fetchAIReport = async (procedureId) => {
  const response = await apiClient.get(
    '/api/AIReports/GenerateProcedureAIReport',
    {
      params: { procedureId },
      timeout: 300000, // 5 minute
    },
  );

  return response.data;
};

/**
 * Obtine raportul AI pentru o achizitie directa.
 * Timeout mare (5 min) - generarea dureaza: download fisier + analiza Claude AI
 */
export const fetchDirectAwardAIReport = async (noticeNo) => {
  const response = await apiClient.get(
    '/api/AIReports/GenerateDirectAwardAIReport',
    {
      params: { noticeId: noticeNo },
      timeout: 300000,
    },
  );

  return response.data;
};

/**
 * Obtine raportul AI pentru un proiect (agregat din multiple proceduri).
 */
export const fetchProjectAIReport = async (projectId) => {
  const response = await apiClient.get(
    '/api/AIReports/GenerateProjectAIReport',
    {
      params: { projectId },
      timeout: 300000,
    },
  );

  return response.data;
};
